/*
 * Permit navigator embed behaviour (the dedicated tool page hosts the iframe).
 *
 *  1. Forward the CTA's context params (category, product, collection, utm_*, ref) to the
 *     iframe. Visitors arrive from a guide/hub/collection CTA or a product page whose link
 *     carries these, and Liquid cannot read the tool page's own query string, so we do it here.
 *     product and collection preselect a model or a range in the tool (permit repo #67); a stale
 *     handle falls back to the normal first step there, so passing one through is always safe.
 *
 *  2. Auto-size the iframe to its content height so the multi-step tool has no
 *     inner scrollbar and reads as part of the page. It only ever grows: the section reserves
 *     the tallest step up front, so moving between steps does not move the page. The embedded app posts
 *       { type: 'permit-tool:resize', height: <px> }
 *     on load and whenever its height changes. 'nsp-permit-height' is also
 *     accepted, which is what this file originally specified; the tool ships the
 *     first name, so both are honoured rather than leaving the page depending on
 *     two repositories agreeing on a string.
 *
 *  3. Scroll the embed back into view when the tool moves between steps, which it
 *     asks for with { type: 'permit-tool:scrollIntoView' }. Without this, advancing
 *     a step leaves the reader halfway down a tall frame looking at nothing.
 *
 *     Every message is checked against the iframe's own origin before it is acted on.
 */
(function () {
  var PASS = ['category', 'product', 'collection', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'ref'];
  var HEIGHT_MSG = ['permit-tool:resize', 'nsp-permit-height'];
  var SCROLL_MSG = 'permit-tool:scrollIntoView';
  // A couple of pixels absorbs subpixel rounding, which is enough on its own to put the
  // scrollbar back. It is also why a height that merely echoes the frame back to us has to be
  // ignored: adding slack to the frame's own height on every message grows the page forever.
  var SLACK = 2;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function embedWraps() {
    return document.querySelectorAll('[data-permit-embed]');
  }
  function originOf(url) {
    try { return new URL(url).origin; } catch (e) { return null; }
  }

  function forwardParams() {
    var wraps = embedWraps();
    if (!wraps.length) return;
    var incoming = new URLSearchParams(window.location.search);
    var pass = new URLSearchParams();
    PASS.forEach(function (key) {
      var v = incoming.get(key);
      if (v) pass.set(key, v);
    });
    if (Array.from(pass).length === 0) return; // nothing to forward, keep server src
    pass.set('embed', '1');
    var query = pass.toString();
    wraps.forEach(function (wrap) {
      var base = wrap.getAttribute('data-embed-base');
      var frame = wrap.querySelector('[data-permit-frame]');
      if (base && frame) frame.src = base.replace(/\/+$/, '') + '/?' + query;
    });
  }

  function initAutoHeight() {
    var wraps = embedWraps();
    if (!wraps.length) return;
    window.addEventListener('message', function (e) {
      var data = e.data;
      if (!data || !data.type) return;
      var isHeight = HEIGHT_MSG.indexOf(data.type) !== -1;
      var isScroll = data.type === SCROLL_MSG;
      if (!isHeight && !isScroll) return;
      var h = parseInt(data.height, 10);
      if (isHeight && (!h || h < 200)) return;
      wraps.forEach(function (wrap) {
        // only act on a message posted from the iframe's own origin
        if (originOf(wrap.getAttribute('data-embed-base')) !== e.origin) return;
        var frame = wrap.querySelector('[data-permit-frame]');
        if (!frame) return;
        if (isHeight) {
          // An embed that measures documentElement.scrollHeight reports the frame's own height
          // back to us, because that value is floored at the viewport. Applying it would add
          // SLACK on top every time and the page would keep growing on its own. Only a change
          // bigger than the slack is real content, so anything smaller is left alone.
          // Grow, never shrink. The section reserves the tool's tallest step as the frame's
          // min-height, so a shorter step leaves the frame where it is and the page does not jump as
          // the reader moves through the tool (Jens, 4 Oct 2026). Only a step taller than anything
          // so far grows it, and it then stays at that height.
          var target = h + SLACK;
          var current = Math.round(frame.getBoundingClientRect().height) || parseInt(frame.style.height, 10) || 0;
          if (target <= current + SLACK) return;
          frame.style.height = target + 'px';
        } else {
          wrap.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
  }

  function init() {
    forwardParams();
    initAutoHeight();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
